'use strict';

var baseUtils = require('lyonscg/util/utils');
var _ = require('lodash');

var utils = {
    /**
     * @function
     * @alias module:util.appendCSRFTokenToURL
     * @description Append csrf token to url
     * @param {string} url - URL
     * @param {Object} $form - The form object
     * @returns {string} - URL with csrf token
     */
    appendCSRFTokenToURL: function (url, $form) {
        return this.appendParamToURL(url, 'csrf_token', $form.find('[name="csrf_token"]').val());
    },

    /**
     * @function
     * @description Executes a callback function when the user has stopped resizing the screen.
     * It will only execute on changes to page width.
     * @param {function} callback - Callback function for the resize event
     */
    smartResize: function (callback) {
        let windowWidth = $(window).innerWidth();

        $(window).resize(_.debounce(() => {
            if (windowWidth !== $(window).innerWidth()) {
                callback();
                windowWidth = $(window).innerWidth();
            }
        }, 100));
    }
};

module.exports = $.extend({}, baseUtils, utils);
